/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteIcon16Solid = forwardRef('CertRosetteIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 6a5.977 5.977 0 0 1-1.541 4.015l1.68 2.4a1 1 0 0 1-.246 1.393l-2.457 1.72a1 1 0 0 1-1.393-.245l-2.045-2.921-2.046 2.92a1 1 0 0 1-1.392.246l-2.458-1.72a1 1 0 0 1-.245-1.393l1.682-2.403A6 6 0 1 1 14 6ZM8 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" })));
});
